import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { prepareHeaders, handleApiError } from './helpers'

export const developerApi = createApi({
  reducerPath: 'developer',
  baseQuery: fetchBaseQuery({
    baseUrl: window.env.API_ENDPOINT,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    getApiDocs: builder.query({
      query: () => ({
        url: 'docs/',
      }),
      async onQueryStarted(_id, { queryFulfilled }) {
        try {
          await queryFulfilled
        } catch (err) {
          handleApiError('api.developer.errors.getApiDocs', err)
        }
      },
    }),
  }),
})

export const { useLazyGetApiDocsQuery } = developerApi
